import Vue from 'vue';

const mutations = {
    setBulbComplexity: (state, val) => state.bulb_complexity = val,
    setComplexityLevels: (state, val) => Vue.set(state, 'complexity_levels', val),
    setNsfId: (state, val) => state.nsf_id = val,
    setSegmentComplexity: (state, val) => Vue.set(state.segment_complexity, val.id, val.complexity),
    setTreatment: (state, val) => state.treatment = val,
}

export default mutations;
